import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Check } from 'lucide-react';
const extras = ['Tu primera máscara y snorkel personal de regalo', 'Remera oficial de la escuela', 'Bitácora oficial para registrar tus inmersiones', 'Voucher del 10% para cursos de educación continua'];
export function BeneficiosInscripcion() {
  return <section className="py-20 sm:py-24 px-6 bg-brand-background relative" data-id="element-29">
      <div className="max-w-3xl mx-auto" data-id="element-30">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10 max-w-2xl mx-auto" data-id="element-31">
          <h3 className="text-brand-primary font-heading font-bold text-3xl sm:text-4xl md:text-5xl uppercase tracking-tight mb-4" data-id="element-32">
            Tu kit de buzo de regalo
          </h3>
          <p className="text-brand-details/90 text-lg font-light" data-id="element-33">
            Al reservar tu lugar hoy, además de tu formación completa, recibís
            beneficios exclusivos incluidos sin costo adicional.
          </p>
        </motion.div>

        {/* Featured primary benefit */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.6
      }} className="relative rounded-3xl border border-brand-primary/60 bg-brand-dark p-6 sm:p-7 mb-6 shadow-[0_22px_70px_-25px_rgba(0,184,217,0.55)] overflow-hidden" data-id="element-34">
          <div className="absolute inset-0 [background:radial-gradient(80%_120%_at_100%_0%,rgba(0,184,217,0.12),transparent_55%)]" data-id="element-35"></div>

          <div className="relative" data-id="element-36">
            <div className="flex items-center gap-3 mb-4 flex-wrap" data-id="element-37">
              <span className="text-brand-details/70 text-xs font-bold tracking-[0.2em] uppercase" data-id="element-38">
                🎁 Beneficio destacado de esta semana
              </span>
              <span className="inline-flex items-center rounded-full border border-brand-primary/40 bg-brand-primary/10 text-brand-primary text-xs font-bold tracking-widest uppercase px-3 py-1" data-id="element-39">
                Beneficio actualmente activo
              </span>
            </div>

            <div className="flex items-start gap-3 mb-4" data-id="element-40">
              <span className="w-10 h-10 rounded-full bg-brand-primary/10 flex items-center justify-center text-brand-primary shrink-0" data-id="element-41">
                <Clock size={20} strokeWidth={1.5} data-id="element-42" />
              </span>
              <h4 className="text-white font-heading font-black text-xl sm:text-2xl uppercase tracking-tight leading-tight" data-id="element-43">
                Más tiempo de agua. Más confianza. Más experiencia.
              </h4>
            </div>

            <div className="space-y-2 text-white/75 leading-relaxed" data-id="element-44">
              <p data-id="element-45">
                Incluimos 3 clases prácticas adicionales de 1 hora cada una.
              </p>
              <p data-id="element-46">
                Pasás de 5 a 8 horas totales de entrenamiento práctico
                supervisado antes de tu certificación.
              </p>
            </div>
          </div>
        </motion.div>

        {/* Además recibís */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5
      }} className="rounded-3xl border border-brand-primary/20 bg-brand-dark p-6 sm:p-8" data-id="element-47">
          <span className="block text-brand-details/70 text-xs font-bold tracking-[0.2em] uppercase mb-5" data-id="element-48">
            Además recibís:
          </span>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4" data-id="element-49">
            {extras.map((item, i) => <li key={i} className="flex items-start gap-3 text-white/90 text-sm sm:text-base" data-id="element-50">
                <span className="w-6 h-6 rounded-full bg-brand-primary/15 border border-brand-primary/40 flex items-center justify-center shrink-0 mt-0.5" data-id="element-51">
                  <Check size={14} className="text-brand-primary" strokeWidth={3} data-id="element-52" />
                </span>
                <span data-id="element-53">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        {/* Discreet legend */}
        <p className="text-white/40 text-xs sm:text-sm text-center mt-8 max-w-xl mx-auto leading-relaxed" data-id="element-54">
          Los beneficios incluidos pueden actualizarse periódicamente según
          disponibilidad y promociones vigentes al momento de la reserva.
        </p>
      </div>
    </section>;
}